<template>
	<section :class="card.category" :title="card.name">
		<!-- TODO: Need the click event to be dynamic such as selectVideoContent(card) or selectFlyerContent(card) -->
		<div
			tabindex="0"
			class="design"
			@keydown.enter="enterClick"
			role="button"
			:aria-label="`Design layout template ${card.index}`"
			:class="[
				card.category,
				{ selected: selected, 'video-title': selectedMediaType === 4 },
			]"
		>
			<div class="b360-fake-img-border"></div>
			<section v-if="selectedMediaType !== 4">
				<img
					:src="card.template.previewUri"
					class="b360-large-image-radio"
					:alt="`${card.name}`"
				/>
			</section>
			<section v-else-if="selectedMediaType === 4">
				<img
					:src="thumbnailPreview"
					class="b360-large-image-radio"
					:alt="`${card.name}`"
				/>
			</section>
			<Radio
				:radioId="`select-card-${radioKey}`"
				radioGroupName="designGroup"
				:isChecked="selected"
				:radioDescription="`media group radio`"
			/>
		</div>
		<!-- selectedMediaType flyer = 1, socialbanner = 2, email = 3, video = 4, ppt = 5, pricing flyer = 6 -->
		<span class="card-title b360-form-label" v-if="selectedMediaType === 4">{{
			card.title
		}}</span>
	</section>
</template>

<script>
import { mapState } from 'vuex';
import Radio from '@/components/global/Radio.vue';

export default {
	name: 'BBDesignCard',
	components: {
		Radio,
	},
	props: {
		default: Boolean,
		isChecked: Boolean,
		card: Object,
		selectType: String,
		radioKey: [String, Number],
		selected: Boolean,
		previewUri: String,
	},
	methods: {
		enterClick() {
			this.$el.click();
		},
	},
	computed: {
		...mapState({
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
		}),
		thumbnailPreview() {
			// eslint-disable-next-line
			return (
				this.card.previewUri ||
				(this.card.uri
					? this.card.uri
							.replace('upload/', 'upload/so_auto/')
							.replace('mp4', 'jpg')
					: '')
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.b360-large-image-radio {
	max-width: 100%;
	display: block;
	border-radius: $b360-border-radius-base;
}

.design {
	margin-bottom: 20px;
	border-radius: $b360-border-radius-medium;
	position: relative;
	display: block;

	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
		display: flex;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: $b360-border-radius-base;
	}

	.custom-radio {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
	}
}

.card-title {
	margin-bottom: 25px;
}

.video-title {
	margin-bottom: 3px;
}

.design {
	&:focus,
	&:active,
	&:hover {
		.b360-fake-img-border {
			box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		}

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}
}
.selected {
	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
	}

	.custom-radio {
		background-color: $brand-teal;
		box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
	}
}

.checkbox {
	height: 18px;
	width: 18px;
	border-radius: $b360-border-radius-medium;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $white;
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 1;

	&:checked {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		background-color: $brand-teal;
		color: $white;
		text-align: center;
		font-family: 'Font Awesome 5 Pro';

		&::after {
			display: inline-block;
			content: ' \2714';
		}
	}
}
</style>
